module.exports = __webpack_public_path__ + "assets/img/element-logo-small.f088544c.svg";